<template>
  <div v-if="livestreams.length" class="container">
    <h3>Streaming live now!</h3>

    <div id="body" class="body">
      <!-- Scroll left -->
      <cp-button v-if="showButtonsScroll && showScrollLeftButton" id="left-button" class="button-move button-left" @click="swipeLeft">
        <cp-icon name="angle-left"></cp-icon>
      </cp-button>

      <div class="center" id="content" ref="content">
        <div v-for="livestream in livestreams" ref="itemsRef" :key="livestream.id" class="internal" @click="goToLivestream(livestream.session_id)">
          <div style="position: relative">
            <img :src="livestream.owner.profile_image" class="livestream-image" />
            <div class="livestream-live-footer">
              <p style="color: white">LIVE</p>
            </div>
          </div>
        </div>
      </div>

      <!-- Scroll right -->
      <cp-button v-if="showButtonsScroll && showScrollRightButton" id="right-button" class="button-move button-right" @click="swipeRight">
        <cp-icon name="angle-right" style="font-size: 15px"></cp-icon>
      </cp-button>
    </div>
  </div>
</template>

<script>
import { fetchLivestreams } from '../api/livestreams';

export default {
  name: 'CpLivestreamList',
  components: {
    CpButton: require('../button').default,
    CpIcon: require('../icon').default,
  },
  data() {
    return {
      livestreams: [],
      showScrollLeftButton: false,
      showScrollRightButton: true,
      showButtonsScroll: false,
      scrollLeft: 0,
      page: 0,
    };
  },
  props: {
    currentUser: { type: Object, default: {} },
  },
  mounted() {
    this.getLivestreams();
  },
  updated() {
    // Handle scroll buttons
    if (this.livestreams.length && this.$refs.content && this.$refs.itemsRef) {
      const contentWidth = this.$refs.content.clientWidth;
      const itemsWidth = (this.$refs.itemsRef[0].clientWidth + 15) * this.$refs.itemsRef.length;

      this.showButtonsScroll = itemsWidth > contentWidth;
    }
  },
  methods: {
    getLivestreams() {
      fetchLivestreams({ page: this.page })
        .then(response => {
          if (response.livestreams.length) {
            let livestreams;
            livestreams = response.livestreams;

            if (this.currentUser) {
              livestreams = livestreams.filter(livestream => livestream.owner.id != this.currentUser.id);
            }

            this.livestreams = this.combineLivestreams(this.livestreams, livestreams);
            this.page += 1;
          }
        })
        .catch(error => {
          console.warn(error);
        });
    },
    combineLivestreams(currItems, newItems) {
      const items = [...currItems];

      for (const newItem of newItems) {
        const index = items.findIndex(livestream => livestream.id == newItem.id);

        if (index > -1) {
          items[index] = { ...items[index], ...newItem };
        } else {
          items.push(newItem);
        }
      }

      return items;
    },
    goToLivestream(key) {
      window.location.href = `/livestreams/${key}`;
    },
    /**
     * scrollTo - Horizontal Scrolling
     * @param {(HTMLElement ref)} element - Scroll Container
     * @param {number} scrollPixels - pixel to scroll
     * @param {number} duration -  Duration of scrolling animation in millisec
     */
    scrollTo(element, scrollPixels, duration) {
      const scrollPos = element.scrollLeft;

      if (element.scrollLeft !== this.scrollLeft) {
        this.showScrollLeftButton = true;
      }

      if (element.scrollLeft == this.scrollLeft && element.scrollLeft > 0) {
        this.showScrollRightButton = false;
      }

      this.scrollLeft = scrollPos;

      // Condition to check if scrolling is required
      if (!((scrollPos === 0 || scrollPixels > 0) && (element.clientWidth + scrollPos === element.scrollWidth || scrollPixels < 0))) {
        // Get the start timestamp
        const startTime = 'now' in window.performance ? performance.now() : new Date().getTime();

        function scroll(timestamp) {
          //Calculate the timeelapsed
          const timeElapsed = timestamp - startTime;
          //Calculate progress
          const progress = Math.min(timeElapsed / duration, 1);
          //Set the scrolleft
          element.scrollLeft = scrollPos + scrollPixels * progress;
          //Check if elapsed time is less then duration then call the requestAnimation, otherwise exit
          if (timeElapsed < duration) {
            //Request for animation
            window.requestAnimationFrame(scroll);
          } else {
            return;
          }
        }
        //Call requestAnimationFrame on scroll function first time
        window.requestAnimationFrame(scroll);
      }
    },
    swipeLeft() {
      const content = this.$refs.content;
      this.scrollTo(content, -210, 500);
      this.showScrollRightButton = true;
      if (this.scrollLeft == 0) this.showScrollLeftButton = false;
    },
    swipeRight() {
      const content = this.$refs.content;
      this.scrollTo(content, 210, 500);
      this.showScrollLeftButton = true;
    },
  },
};
</script>

<style scoped>
.container {
  margin-bottom: 25px;
}
.body {
  display: flex;
  position: relative;
}
.internal {
  height: 100%;
  display: inline-block;
  margin-right: 15px;
  cursor: pointer;
}
.center {
  float: left;
  width: 100%;
  height: auto;
  overflow: hidden;
  white-space: nowrap;
  margin-left: 10px;
}
.livestream-image {
  height: 75px;
  width: 75px;
  border-radius: 50%;
  border-width: 3px;
  border-style: solid;
  border-color: #ff4814;
  object-fit: cover;
}
.livestream-live-footer {
  position: absolute;
  background-color: #ff4814;
  border-radius: 5px;
  height: 20px;
  width: 45px;
  display: flex;
  align-items: center;
  justify-content: center;
  bottom: 0px;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
  /* Font style */
  font-family: 'proxima-nova', Gotham, Helvetica, sans-serif;
  font-weight: 400;
  color: #fff;
  font-size: 11px;
}
.button-move {
  border-radius: 50px;
  border: none;
  background-color: white;
  border-width: 1px;
  border-style: solid;
  border-color: #ff4814;
  height: 35px;
  width: 35px;
  display: flex;
  justify-content: center;
  position: absolute;
}
.button-left {
  left: -10px;
  z-index: 1000;
}
.button-right {
  right: -10px;
}

@media (max-width: 768px) {
  .livestream-image {
    height: 55px;
    width: 55px;
  }

  .livestream-live-footer {
    font-size: 10px;
    height: 15px;
    width: 40px;
  }
}
</style>
